import {toURL} from '@homeaway/search-url-parser';

import {
    getUrlSearchParamsString,
    hasFilledDates
} from './';

function getSearchValues(destination, dates, guests) {
    const {
        destination: search,
        listingProps: listing
    } = destination.latestValues;

    const {
        startDate,
        endDate
    } = dates.latestValues;

    const {
        adultsCount,
        childrenCount,
        petIncluded
    } = guests.latestValues;

    return {
        search,
        listing,
        startDate,
        endDate,
        adultsCount,
        childrenCount,
        petIncluded
    };
}

function getSearchFilters(search, destination) {
    const {
        filters: searchFilters
    } = search.latestValues;

    const {
        getFilter: getDestinationFilter
    } = destination.selectors;

    const destinationFilter = getDestinationFilter();

    const filters = [destinationFilter, ...searchFilters].map((filter) => (
        !isNaN(parseInt(filter, 10))
            ? `filter:${filter}`
            : null
    ));

    return Array.from(new Set(filters.filter(Boolean)));
}

function getListingSearchRequest(destination, dates, guests) {
    const searchValues = getSearchValues(destination, dates, guests);

    const {
        listing: {
            listingUrl,
            unitId
        },
        startDate: arrival,
        endDate: departure,
        adultsCount,
        childrenCount,
        petIncluded
    } = searchValues;

    return {
        listingUrl,
        unitId,
        arrival,
        departure,
        adultsCount,
        childrenCount,
        petIncluded
    };
}

// eslint-disable-next-line complexity
function getListingSearchPath(destination, dates, guests) {
    const searchRequest = getListingSearchRequest(destination, dates, guests);

    const {
        listingUrl,
        unitId,
        arrival,
        departure,
        adultsCount,
        childrenCount,
        petIncluded
    } = searchRequest;

    const separator = unitId ? '&' : '?';

    const params = getUrlSearchParamsString({
        ...(
            hasFilledDates(arrival, departure)
                ? {arrival, departure}
                : {noDates: true}
        ),
        ...(adultsCount && {adultsCount}),
        ...(childrenCount && {childrenCount}),
        ...(petIncluded && {petIncluded})
    });

    return `${listingUrl}${separator}${params}`;
}

function getLocationSearchRequest(search, destination, dates, guests) {
    const searchValues = getSearchValues(destination, dates, guests);

    const {
        search: q,
        startDate: arrival,
        endDate: departure,
        adultsCount,
        childrenCount,
        petIncluded
    } = searchValues;

    const filter = getSearchFilters(search, destination);

    return {
        q,
        arrival,
        departure,
        adultsCount,
        childrenCount,
        petIncluded,
        filter
    };
}

function getLocationSearchPath(search, destination, dates, guests) {
    const searchRequest = getLocationSearchRequest(search, destination, dates, guests);

    return toURL(searchRequest);
}

function getSearchPath(search, destination, dates, guests) {
    return (
        destination.selectors.isListingSearch()
            ? getListingSearchPath(destination, dates, guests)
            : getLocationSearchPath(search, destination, dates, guests)
    );
}

function getSearchData(search, destination, dates, guests) {
    const searchValues = getSearchValues(destination, dates, guests);
    const searchPath = getSearchPath(search, destination, dates, guests);

    return {
        ...searchValues,
        searchPath
    };
}

export {
    getListingSearchPath,
    getListingSearchRequest,
    getLocationSearchPath,
    getLocationSearchRequest,
    getSearchData,
    getSearchFilters,
    getSearchPath,
    getSearchValues
};
